<mat-select translate="no" [formControl]="control" [placeholder]="placeholder">
    <ng-container *ngIf="interfs.length > 1; else onlyOne">
        <mat-optgroup translate="no" *ngFor="let interf of interfs" [label]="interf.name">
            <mat-option translate="no" *ngFor="let entity of options.get(interf)" [value]="optionValue(entity)">
                {{ interf.getName(entity) }}
            </mat-option>
        </mat-optgroup>
    </ng-container>
    <mat-option *ngIf="cargandoOpciones" class="cargando-opciones" disabled>
        <mat-spinner diameter="16" style="display: inline-block; vertical-align: middle; margin-right: 8px"></mat-spinner>
        Cargando…
    </mat-option>
    <ng-template #onlyOne>
        <mat-option translate="no" *ngFor="let entity of options.get(interfs[0])" [value]="optionValue(entity)">
            {{ interfs[0].getName(entity) }}
        </mat-option>
    </ng-template>
</mat-select>
